import React from "react";
import {FirstPage} from "../FirstPage/FirstPage";

export function HomePage(){
    return <FirstPage/>
}